import {Component, Input} from '@angular/core';
import {BreadcrumbItem} from '../../shared.model';

@Component({
  selector: 'iaud-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input()
  breadcrumbList: Array<BreadcrumbItem>;
}
